<template>
    <div id="events-manage" v-if="events">
        <div class="events-header">
            <span>BROJ</span>
            <span>IME</span>
            <span>OPIS</span>
            <span>TIP</span>
            <span>TEMATIKA</span>
            <span>POČETAK</span>
            <span>KRAJ</span>
            <span>PROSTORIJA</span>
        </div>
        <div class="event" v-for="(event, index) in events" v-bind:key="event.id">
            <span>{{index+1}}.</span>
            <span>{{event.name}}</span>
            <span>{{event.description}}</span>
            <span>{{event.type}}</span>
            <span>{{event.theme ? event.theme : 'NEMA'}}</span>
            <span>{{event.starts}}</span>
            <span>{{event.ends}}</span>
            <span v-if="event.venue">{{event.venue.name}}</span>
            <span v-else>Nepoznato</span>
            <button type="button" v-on:click="openAddEditModal(event)">UREDI</button>
            <button type="button" v-on:click="deleteEvent(event)">IZBRIŠI</button>
        </div>
        <button type="button" v-on:click="openAddEditModal()">DODAJ</button>
        <AddEditEventModal v-if="modalVisible" v-on:cancel="resetEvent" v-on:save="saveEvent" v-bind:event="eventForModal" 
            v-bind:eventTypes="eventTypes" v-bind:eventThemes="eventThemes" v-bind:speakers="speakers" v-bind:venues="venues" 
            v-bind:companies="companies" v-bind:achievementCodes="achievementCodes" />
    </div>
</template>

<script>
    import AddEditEventModal from '@/components/admin/events/AddEditEventModal.vue';

    export default {
        name: 'EventManage',
        data() {
            return {
                events: [],
                eventForModal: {},
                modalVisible: false,
                eventTypes: [],
                eventThemes: [],
                speakers: [],
                venues: [],
                companies: [],
                achievementCodes: []
            }
        },
        components: {
            AddEditEventModal
        },
        methods: {
            openAddEditModal: function (event) {
                this.eventForModal = event ? event : {};
                this.modalVisible = true;
            },
            saveEvent: function (eventToSave) {
                if (eventToSave.id){
                    this.$axios.post(`${this.$API_URL}/events/edit`, eventToSave
                    ).catch(() => {
                        this.$axios.get(`${this.$API_URL}/events/${eventToSave.id}`).then(response => {
                            this.events.splice(this.events.findIndex(event => event.id === eventToSave.id), 1, response.data);
                            alert('Edit eventa neuspješan. Nevaljan unos ili zabranjen pristup.');
                        }).catch(() => {
                            alert('Nešto je pošlo po krivu pri editu eventa!');
                        });
                    });
                    }
                else
                    this.$axios.post(`${this.$API_URL}/events/add`, eventToSave
                    ).then(response => {
                        eventToSave.id = response.data;
                        this.events.push(eventToSave);
                    }).catch(() => {
                        alert('Dodavanje eventa neuspješno. Nevaljan unos ili zabranjen pristup.');
                    });
                this.modalVisible = false;
            },
            resetEvent: function (eventToReset) {
                if(eventToReset.id)
                    this.$axios.get(`${this.$API_URL}/events/${eventToReset.id}`).then(response => {
                        this.events.splice(this.events.findIndex(event => event.id === eventToReset.id), 1, response.data); });
                this.modalVisible = false;
            },
            deleteEvent: function (eventToDelete) {
                if(confirm(`Jeste li sigurni da želite izbrisati događaj ${eventToDelete.name}?`))
                    this.$axios.delete(`${this.$API_URL}/events/delete/${eventToDelete.id}`).then(() => {
                        this.events.splice(this.events.findIndex(event => event.id === eventToDelete.id), 1);
                    }).catch(() => {
                        alert('Brisanje eventa neuspješno. Nevaljan unos ili zabranjen pristup.');
                    });
            }
        },
        created() {
            this.$axios.get(`${this.$API_URL}/events/all-events`).then(response => {
                this.events = response.data;
            });
            this.$axios.get(`${this.$API_URL}/events/event-type-enum`).then(response => {
                this.eventTypes = response.data;
            });
            this.$axios.get(`${this.$API_URL}/events/event-theme-enum`).then(response => {
                this.eventThemes = response.data;
            });
            this.$axios.get(`${this.$API_URL}/user/speakers`).then(response => {
                this.speakers = response.data;
            });
            this.$axios.get(`${this.$API_URL}/venues/all-venues`).then(response => {
                this.venues = response.data;
            });
            this.$axios.get(`${this.$API_URL}/companies/all-companies`).then(response => {
                this.companies = response.data;
            });
             this.$axios.get(`${this.$API_URL}/achievements/code/all-codes`).then(response => {
                this.achievementCodes = response.data;
            });
        }
    }
</script>

<style scoped>
    .events-header span,
    .event span {
        word-wrap: break-word;
        display: inline-block;
        height: auto;
        width: 12%;
        margin-right: 5px;
        vertical-align: center;
    }

    span:nth-child(1) {
        width: 5%;
    }

    button {
        padding: 6px;
    }
</style>